import { createSlice } from '@reduxjs/toolkit'

const slicer = (initialState = {}) =>
  createSlice({
    name: 'data',
    initialState,
    reducers: {
      changeMode: (state, { payload }) => {
        state.mode = payload.mode
      },
      isLoading: (state, { payload }) => {
        state.loading = payload
      },
      setData: (state, { payload }) => {
        return { ...state, ...payload }
      }
    }
  })

export const generateSlice = initState => {
  const { actions, reducer } = slicer(initState)
  return { actions, reducer }
}

// use empty slicer, to make generated actions available, current ssr implementations are unstable
export const { changeMode, isLoading, setData } = slicer().actions
